import Form from "../form/Form";

const Hero = () => {
    return (
        <section className="relative w-full bg-black overflow-hidden px-6 md:px-12 flex justify-center flex-col">
            {/*BACKGROUND */}
            <div className="absolute inset-0 z-0">
                <img
                    src="./images/man-mob.png"
                    alt="Brand Partnership Background"
                    className="w-full h-full object-cover"
                />

                {/* gradients */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent" />

            </div>

            {/* CONTENT WRAPPER */}
            <div className="relative z-10 flex items-center min-h-screen">
                <div className="w-full max-w-[1440px] mx-auto py-20 lg:py-28">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
                        {/*  LEFT CONTENT*/}
                        <div className="text-white flex flex-col items-start gap-8">
                            {/* Tag */}
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm">
                                <svg
                                    className="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M7 20H2v-2a3 3 0 015.356-1.857m9.288-1.857a5.002 5.002 0 00-9.288 0M15 7a3 3 0 11-6 0"
                                    />
                                </svg>
                                <span className="text-[11px] uppercase tracking-widest font-semibold">
                                    Partnership Program
                                </span>
                            </div>

                            {/* Heading */}
                            <h1 className="text-4xl sm:text-5xl md:text-6xl font-normal leading-tight">
                                Turn Your Idea Into a
                                <br />
                                <span className="text-neutral-400">Global Brand.</span>
                            </h1>

                            {/* Description */}
                            <p className="text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed max-w-xl">
                                Launch your private label in Fashion, Home Decor, Gifting, or any
                                category we source. We handle the manufacturing, legal, and
                                logistics—so you can focus on growing your business.
                            </p>

                            {/* CTA */}
                            <button className="bg-[#D91F26] hover:bg-[#b0191f] text-white px-8 py-4 rounded shadow-lg hover:shadow-red-900/30 transition-all duration-300">
                                Start Your Brand Journey
                            </button>
                        </div>

                        {/*  RIGHT FORM  */}
                        <div className="w-full max-w-lg mx-auto lg:ml-auto">
                            <Form />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
